module.exports = __webpack_public_path__ + "static/media/offc-enhance-wx.573ddbdc.png";